<template>
  <div class="c-base-date-input" :class="{ 'c-base-form__form-group--error': $v.form.$anyError }">
    <base-input-group>
      <base-input
        id="day"
        class="c-base-date-input__day"
        name="day"
        :placeholder="`${new Date().getDate()}`"
        v-model="$v.form.day.$model"
        :state="state === false ? state : getValidationState($v.form.day)"
        :required="required"
        :lazy="true"
      />
      <base-select
        id="month"
        name="month"
        class="c-base-date-input__month flex-grow"
        :options="monthOptions"
        v-model="$v.form.month.$model"
        :state="state === false ? state : getValidationState($v.form.month)"
        :placeholder="$t('label.selectA{label}', { label: $t('label.month').toLowerCase() })"
        :is-searchable="false"
      />
      <base-input
        id="year"
        name="year"
        class="c-base-date-input__year"
        :placeholder="`${new Date().getFullYear()}`"
        v-model="$v.form.year.$model"
        :state="state === false ? state : getValidationState($v.form.year)"
        :required="required"
        :lazy="true"
      />
    </base-input-group>

    <div class="c-base-form__error-message" v-if="!$v.form.day.between">{{ $t('system.between', { label: $t('label.day'), min: $v.form.day.$params.between.min, max: $v.form.day.$params.between.max }) }}</div>
    <div class="c-base-form__error-message" v-if="!$v.form.day.required && $v.form.day.$dirty" >{{ $t('system.isRequired', { label: $t('label.day') }) }}</div>

    <div class="c-base-form__error-message" v-if="!$v.form.month.between">{{ $t('system.between', { label: $t('label.month'), min: $v.form.month.$params.between.min, max: $v.form.month.$params.between.max }) }}</div>
    <div class="c-base-form__error-message" v-if="!$v.form.month.required && $v.form.month.$dirty" >{{ $t('system.isRequired', { label: $t('label.month') }) }}</div>

    <div class="c-base-form__error-message" v-if="!$v.form.year.minLength">{{ $t('system.minDigits', { min: $v.form.year.$params.minLength.min }) }}</div>
    <div class="c-base-form__error-message" v-if="!$v.form.year.maxLength">{{ $t('system.maxDigits', { max: $v.form.year.$params.maxLength.max }) }}</div>
    <div class="c-base-form__error-message" v-if="!$v.form.year.required && $v.form.year.$dirty">{{ $t('system.isRequired', { label: $t('label.year') }) }}</div>
  </div>
</template>

<script>
import { required, between, minLength, maxLength } from 'vuelidate/lib/validators'
import { validationState } from '@/mixins/helpers'

export default {
  name: 'BaseDateInput',

  mixins: [validationState],

  props: {
    value: {
      type: [Date, String]
    },
    state: {
      type: Boolean,
      required: false
    },
    required: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      form: {
        day: undefined,
        month: null,
        year: undefined
      },
      monthOptions: [
        { value: '0', label: this.$i18n.t('label.january') },
        { value: '1', label: this.$i18n.t('label.february') },
        { value: '2', label: this.$i18n.t('label.march') },
        { value: '3', label: this.$i18n.t('label.april') },
        { value: '4', label: this.$i18n.t('label.may') },
        { value: '5', label: this.$i18n.t('label.june') },
        { value: '6', label: this.$i18n.t('label.july') },
        { value: '7', label: this.$i18n.t('label.august') },
        { value: '8', label: this.$i18n.t('label.september') },
        { value: '9', label: this.$i18n.t('label.october') },
        { value: '10', label: this.$i18n.t('label.november') },
        { value: '11', label: this.$i18n.t('label.december') }
      ]
    }
  },

  mounted () {
    this.$watch(() => this.value, value => {
      if (value) {
        const date = value instanceof Date ? value : new Date(value)

        Object.assign(this.form, {
          day: `${date.getDate()}`,
          month: `${date.getMonth()}`,
          year: `${date.getFullYear()}`
        })
      }
    }, { immediate: true })

    this.$watch(() => this.$v.form.$model, model => {
      if (!this.$v.form.$invalid && model.year > 0 && model.month >= 0 && model.day > 0) {
        this.$emit('input', new Date(model.year, model.month, model.day))
      }
    }, { deep: true })

    this.$watch(() => this.$v.form.$invalid, invalid => {
      if (invalid) {
        this.$emit('input', null)
      }
    })
  },

  validations () {
    return {
      form: {
        day: { required, between: between(1, 31) },
        month: { required, between: between(0, 12) },
        year: { required, minLength: minLength(4), maxLength: maxLength(4) }
      }
    }
  }

}
</script>

<style lang="postcss" scoped>
.c-base-date-input {
  &__day, &__year {
    max-width: 90px;
  }
}
</style>
